module.exports = __webpack_public_path__ + "img/howtouse05.f48d2975.jpg";